import React, { useState, useEffect } from 'react'
import PaymentModal from '../modals/payment-modal'
import PropTypes from 'prop-types'
import SectionHeader from './section-header'
import PaymentForm from '../forms/payment-form'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

function PaymentSection(props) {
  const { step, location, paymentParams } = props
  const paymentStep = step == 'payment'
  const [stripePromise, setStripePromise] = useState(null)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (step == 'payment') {
      setShowModal(true)
      createStripePromise()
    }
  }, [step])

  const createStripePromise = () => {
    setStripePromise(() => loadStripe(paymentParams.publishableKey, {stripeAccount: paymentParams.account}))
  }

  return (
    <div className='payment'>
      { showModal && 
        <PaymentModal 
          phone={location.phone}
          store={!paymentParams.autoCharge}
          onClose={() => setShowModal(false)}
        />
      }
      <SectionHeader title='PAYMENT' />
      { paymentStep &&
        <div className='row'>
          <div className='col-xs-12 col-md-6'>
            <Elements stripe={stripePromise}>
              <PaymentForm
                token={props.token}
                step={props.step}
                price={props.price}
                autoCharge={paymentParams.autoCharge}
                currency={paymentParams.currency}
                alert={props.alert}
                isLoading={props.isLoading}
                totalAmount={props.totalAmount}
                totalFee={props.totalFee}
                fieldSizes={props.fieldSizes}
                selectedSize={props.selectedSize}
                selectedDate={props.selectedDate}
                selectedDuration={props.selectedDuration}
                selectedInterval={props.selectedInterval}
                onPayment={props.onPayment}
              />
            </Elements>
          </div>
        </div>
      }
    </div>
  )
}

PaymentSection.propTypes = {
  step: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  price: PropTypes.number,
  totalAmount: PropTypes.number,
  totalFee: PropTypes.number,
  alert: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  paymentParams: PropTypes.object.isRequired,
  fieldSizes: PropTypes.object.isRequired,
  selectedSize: PropTypes.string.isRequired,
  selectedDate: PropTypes.object.isRequired,
  selectedDuration: PropTypes.string.isRequired,
  selectedInterval: PropTypes.object.isRequired,
  onPayment: PropTypes.func.isRequired,
}

export default PaymentSection
